
import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  @Prop()
  private data: any;
  @Prop()
  private ifCompose: any;
  private get c() {
    this.$forceUpdate();
    return this.data;
  }
  private set c(val) {
    this.$emit("update", val);
  }
  private clickCheckbox(item: any) {
    if (!item.value) {
      item.content = "";
      if (item["options"] && item["options"].length > 0) {
        item["options"].forEach((ele: any) => {
          ele.value = false;
          ele.content = "";
        });
      }
    }
  }
}
